export const stateDurumEnum = {
    IptalEdildi : 0,
    Belediyede : 1,
    Basvuranda : 2,
    Basarili : 3
}

export const ebBasvuruMuellifYetkiEnum = {
    1 : 'Ana Yetkili Müellif',
    2 : 'Bazı Belgeler İçin Ek Müellif',
    3 : 'Ortak Müellif',
    4 : 'Fenni Mesul Müellif',
    5 : 'Yapı Denetim Müellif'
}

export const kodEbBasvuruMuellifYetkiEnum = {
    AnaYetkiliMuellif : 1 ,
    BaziBelgelerIcinMuellif : 2,
    OrtakMuellif : 3,
    FenniMuellif : 4,
    YapiDenetimMuellif : 5
}


export const kodEbEditorType = {
    Input : 1,
    InputNumber : 2,
    Select : 3,
    Checkbox : 4,
    DateTime : 5,
    InputTag : 6,
    InputNumberTag : 7,
    DateTimeTag : 8,
    MultiRowTable : 9,	
	MultiSelect : 10

}

export const kodEbTypeCode = {
    Empty: 0,
    Object: 1,
    DBNull: 2,
    Boolean : 3,
    Char : 4,
    SByte : 5,
    Byte : 6,
    Int16 : 7,
    UInt16 : 8,
    Int32 : 9,
    UInt32 : 10,
    Int64 : 11,
    UInt64 : 12,
    Single : 13,
    Double : 14,
    Decimal : 15,
    DateTime : 16,
    String : 18
}

export const kurumAdi = {
    Cesme : "ÇEŞME",
    Carsamba : "ÇARŞAMBA"
}